import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class CommunityRedirectGuard implements CanActivate {
  constructor(
    private roleService: RoleService,
    private local: LocalServiceService,
    public router: Router,
    public sharedService: SharedService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {

    if (this.local.getUser()?.id || !this.sharedService.isBrowser()) {
      return true;
    } else {
      this.router.navigate(['/']);
    }

    return false;
  }
}
